import React, { Suspense } from "react";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute } from "../../../../_metronic/layout/components/content/ContentRoute";
import Store from "./store";
import StoreDetail from "./storeDetail/storeDetail";
import BranchRegister from "../branch/branchRegister";
import CreateStore from "./createStore";
import BranchesTable from "../branch/branchesTable";
import Iban from "../../Iban/iban";
import SupplierBranchUser from "../../SupplierBranchUser/supplierBranchUser";
import SupplierBranchUserDetail from "../../SupplierBranchUser/SupplierBranchUserDetail";
import BranchUserTable from "../branch/branchUserTable";
import AssignBranchToIban from "../../Iban/AssignBranchToIban";
import ProductCategoryList from "../../defineCategory/productCategoryList";
import ProductSubgroupTable from "../../defineCategory/ProductSubgroupTable";
import CollaborationStores from "../../CollaborationStores/collaborationStores";
import CollaborationStoreDetail from "../../CollaborationStores/collaborationStoreDetail";

export default function StoreConfigPage() {
  return (
    <Switch>
      {
        /* Redirect from eCommerce root URL to /customers */
        <Redirect exact={true} from="/store" to={`/store/storesTable`} />
      }
      <ContentRoute
        path="/store/storesTable"
        component={Store}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/store/StoreDetail"
        component={StoreDetail}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/store/BranchesTable"
        component={BranchesTable}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/store/BranchRegister"
        component={BranchRegister}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/store/CreateStore"
        component={CreateStore}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/store/Iban/AssignBranchToIban"
        component={AssignBranchToIban}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/store/Iban"
        component={Iban}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/store/CollaborationStores"
        component={CollaborationStores}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/store/CollaborationStoreDetail"
        component={CollaborationStoreDetail}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/store/SupplierBranchUser/SupplierBranchUserDetail"
        component={SupplierBranchUserDetail}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/store/SupplierBranchUser"
        component={SupplierBranchUser}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/store/BranchUserTable"
        component={BranchUserTable}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/store/ProductCategoryList"
        component={ProductCategoryList}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/store/ProductSubgroupTable"
        component={ProductSubgroupTable}
        label={undefined}
        children={undefined}
        render={undefined}
      />
    </Switch>
  );
}
